// extracted by mini-css-extract-plugin
module.exports = {"tab-list":"TabList--tab-list--2hNwl","tabList":"TabList--tab-list--2hNwl"};